<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M6 12c0-.3183.12643-.6235.35147-.8485.22505-.2251.53027-.3515.84853-.3515h9.6c.3183 0 .6235.1264.8485.3515.2251.225.3515.5302.3515.8485 0 .3182-.1264.6235-.3515.8485-.225.2251-.5302.3515-.8485.3515H7.2c-.31826 0-.62348-.1264-.84853-.3515C6.12643 12.6235 6 12.3182 6 12Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M5 12c0-.5523.44772-1 1-1h12c.5523 0 1 .4477 1 1s-.4477 1-1 1H6c-.55228 0-1-.4477-1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
